export function isBlankString(s: string | null | undefined): boolean {
  return s == null || !s.trim();
}
